import { useState } from 'react';
import useDebugMode from '../hooks/useDebugMode';
import styles from './DebugFab.module.css';
import { DebugInfoPanel } from './DebugInfoPanel';

const DebugFab: React.FC = () => {
    const debugMode = useDebugMode();
    const [open, setOpen] = useState<boolean>(false);

    if (!debugMode) return null;

    return (
        <div className={styles.container}>
            {open && <DebugInfoPanel onClose={() => setOpen(false)} />}
            <button
                type="button"
                className={styles.fab}
                onClick={() => setOpen((prev) => !prev)}
                aria-expanded={open}
                title="Debug info"
            >
                {'</>'}
            </button>
        </div>
    );
};

export default DebugFab;
